import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { LayoutProvider, LayoutSplashScreen } from "../_metronic/layout/core";
import { MasterInit } from "../_metronic/layout/MasterInit";
import AuthInit from "./modules/auth/redux/AuthInit";
import { ServerErrorAlert } from "./system/errors/ServerErrorAlert";
import { AppInsightsContext } from "@microsoft/applicationinsights-react-js";
import { reactPlugin } from "setup/appInsights/ApplicationInsightsService";
import ErrorHandler from "./pages/errors/ErrorHandler";

const App = () => {
  return (
    <AppInsightsContext.Provider value={reactPlugin}>
      <Suspense fallback={<LayoutSplashScreen />}>
        <LayoutProvider>
          <AuthInit>
            <Outlet />
            <ServerErrorAlert />
            <ErrorHandler />
            <MasterInit />
          </AuthInit>
        </LayoutProvider>
      </Suspense>
    </AppInsightsContext.Provider>
  );
};

export { App };
